import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type NavBoxProps = {
	className?: string;
	children: React.ReactNode;
};

export const NavBox = ({ children, className }: NavBoxProps) => {
	return (
		<section className={clsx(styles.navBox, className)}>{children}</section>
	);
};
